import { FC } from "react"
import { ID, KTSVG } from "../../../../_metronic/helpers"
import clsx from "clsx"

type Props = {
  idx?: number
  className?: string
  fileId?: ID
  fileName: string
  onSelect?: Function
  onRemove?: Function
}
export const AttachmentCard:FC<Props> = ({idx, className = '', fileId, fileName, onSelect, onRemove}) => {
    
  return (
  <div 
    className={clsx(
      `${className ? className : ''} rounded border border-muted attachment-card px-4 py-2 d-flex flex-column align-items-stretch`, 
      { 'bg-hover-light-info' : onSelect}
    )}     
    data-idx={idx} 
    data-id={fileId}
    onClick={ e => { if (onSelect) onSelect(e)}}
  >
    <div className="d-flex flex-row align-items-start gap-2">
      <KTSVG path='/media/icons/duotune/files/fil003.svg' className='svg-icon-1' />
      <div className="fs-7 fw-bold flex-grow-1 lh-1">
        {fileName}
      </div>
      { onRemove && 
      <div 
        className="rounded bg-light-danger bg-hover-danger me-n2" 
        onClick={ e => { if (onRemove) onRemove(e)}}
        title="remove"
      >
        <KTSVG path='/media/icons/duotune/arrows/arr088.svg' className='svg-icon-1' />
      </div>                
      }                
    </div>            
  </div>
  )        
}